"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlashIcon = void 0;
var React = require("react");
var StarImg = "https://li0.rightinthebox.com/imagegy/202101/e715bfe1572c44f2be65f7b029ec6537flashsale%20icon%402x.png";
exports.FlashIcon = function (props) {
    var size = props.size;
    return (React.createElement("img", { src: StarImg, style: {
            width: size,
            aspectRatio: "1"
        } }));
};
